var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("c-button2", {
        staticClass: "button",
        attrs: {
          size: "small",
          label: "Коды в табеле",
          disabled: _vm.disabled,
        },
        on: { click: _vm.toggle },
      }),
      _vm.isOpened
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "shadow-scroll-container",
                { staticClass: "list" },
                _vm._l(_vm.codes, function (item) {
                  return _c("div", { key: item.id, staticClass: "item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item__code",
                        style: {
                          background: item.color,
                        },
                      },
                      [_vm._v(" " + _vm._s(item.code) + " ")]
                    ),
                    _c("div", { staticClass: "item__name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                  ])
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }